import React from 'react'
import logoImage from '@/assets/tixxly-logo.svg'

interface TinxliLogoProps {
    width?: number | string
    height?: number | string
    className?: string
    style?: React.CSSProperties
}

/**
 * Tixxly Logo Component
 * 
 * Logo Guidelines:
 * - Primary Logo: Custom geometric typeface with rounded terminals and colored dot accents
 * - Variants: Full-color logo on dark background (preferred) or light/white background
 * - Clear Space: Maintain padding equal to the height of the "T" around all sides
 * - Don't rotate, skew, or recolor any elements
 * - Don't apply shadows or outlines
 */
export function TinxliLogo({
    width = 120,
    height = 'auto',
    className,
    style
}: TinxliLogoProps) {
    // Calculate clear space (padding equal to height of "T")
    // Assuming the logo height represents the "T" height, we use a proportional padding
    const clearSpace = typeof height === 'number' ? height * 0.1 : 8

    return (
        <img
            src={logoImage}
            alt="Tixxly"
            width={width}
            height={height}
            className={className}
            style={{
                display: 'block',
                padding: `${clearSpace}px`,
                objectFit: 'contain',
                // No filters, transforms, or effects per guidelines
                // Variant is available for future use if different logo files are needed
                ...style
            }}
        />
    )
}

